export default __webpack_public_path__ + "static/media/people-2.c41faf80.svg";